/**
 * 路由白名单配置
 * Created by PeakXin on 2025/11/13
 * 用于定义无需登录即可访问的页面
 */

export const WHITE_LIST = [
  '/',
  '/404',
  '/error',
  '/previousservice',
  '/previousservice/addservice',
  '/art/lottery',
  '/demo/captcha',
  '/fraction/alevel',
  '/fraction/ig',
  '/ccroom/missing',
  '/video/play',
]
